<script setup lang="ts">

const props = withDefaults(defineProps<{error?: string}>(), {})
</script>

<template>
  <ui-custom-icon class="error-text" :class="{'error-text--show': !!props.error}" icon="core-warning" color="var(--error)"
                  :is-clickable="false" :size="14"><span
      class="error-text__text">{{ props.error }}</span></ui-custom-icon>
</template>

<style scoped lang="scss">
@use 'assets/css/tokens/colors' as *;
@use 'assets/css/tokens/typography' as *;

.error-text {
  display: none;
}

.error-text.error-text--show {
  display: block;
}

.error-text__text {
  font-weight: 400;
  font-size: $font-size-10;
  line-height: $line-height-14;
  color: $color-error;
  margin-left: 0.2rem;
}
</style>
